import React from 'react';

export type ImapProvider = 'outlook' | 'google' | 'yahoo' | 'aol' | 'icloud' | 'custom';

export interface ImapConfig {
  provider: ImapProvider | '';
  username: string;
  password: string;
  host: string;
  port: number;
  ssl: boolean;
}

export function defaultImapConfig(): ImapConfig {
  return { provider: '', username: '', password: '', host: '', port: 993, ssl: true };
}

interface Props {
  config: ImapConfig;
  onChange: (config: ImapConfig) => void;
  disabled: boolean;
}

// IMAP step 2: pick an email provider (logo radios), or "custom" for any other mailbox.
const PROVIDERS: { id: ImapProvider; img: string; imgStyle: React.CSSProperties }[] = [
  { id: 'outlook', img: 'images/email/outlook.png', imgStyle: { maxWidth: 128, maxHeight: 128, marginTop: -10 } },
  { id: 'google',  img: 'images/email/google.png',  imgStyle: { maxWidth: 100, maxHeight: 100, marginTop: -7 } },
  { id: 'yahoo',   img: 'images/email/yahoo.png',   imgStyle: { maxWidth: 100, maxHeight: 100, marginTop: -7 } },
  { id: 'aol',     img: 'images/email/aol.png',     imgStyle: { maxWidth: 75, maxHeight: 75, marginTop: -7 } },
  { id: 'icloud',  img: 'images/email/icloud.png',  imgStyle: { maxWidth: 55, maxHeight: 55, marginTop: -20, marginLeft: -5 } },
];

export function ImapProviderSelect({ config, onChange, disabled }: Props) {
  const select = (provider: ImapProvider) => onChange({ ...config, provider });

  return (
    <div style={{ padding: 10 }}>
      {PROVIDERS.map(p => (
        <div key={p.id} style={{ height: 55 }}>
          <div className="radio radio-primary">
            <input
              id={`imap-${p.id}`}
              type="radio"
              name="imapProvider"
              value={p.id}
              checked={config.provider === p.id}
              onChange={() => select(p.id)}
              disabled={disabled}
            />
            <label htmlFor={`imap-${p.id}`}>
              <img src={p.img} alt={p.id} style={p.imgStyle} />
            </label>
          </div>
        </div>
      ))}
      <div style={{ height: 55 }}>
        <div className="radio radio-primary">
          <input
            id="imap-custom"
            type="radio"
            name="imapProvider"
            value="custom"
            checked={config.provider === 'custom'}
            onChange={() => select('custom')}
            disabled={disabled}
          />
          <label
            htmlFor="imap-custom"
            // Sized to sit alongside the provider logos in the same 55px row.
            style={{ fontSize: 20, lineHeight: '.9em' }}
          >
            Add other email account ..
          </label>
        </div>
      </div>
    </div>
  );
}
